import { render, staticRenderFns } from "./PwReset.vue?vue&type=template&id=67a2e762&scoped=true&"
import script from "./PwReset.vue?vue&type=script&lang=js&"
export * from "./PwReset.vue?vue&type=script&lang=js&"
import style0 from "./PwReset.vue?vue&type=style&index=0&id=67a2e762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a2e762",
  null
  
)

export default component.exports